import { PrimaryButton, SecondaryButton } from "extranet-component-library";
import React from "react";
import { useTranslation } from "react-i18next";


const ConfirmModal = ({ onReject, onAccept }: any) => {
    const { t } = useTranslation();

    return (
        <div className="modal-confirm">
            <div className="content">
                <div className="title">{t('modal.title')}</div>
                <div className="message"> {t('modal.message')}</div>
                <div className="buttons">
                    <PrimaryButton
                        text={t("modal.accept")}
                        onClick={() => onAccept()}
                    />
                    <SecondaryButton
                        text={t("modal.reject")}
                        onClick={() => onReject()}
                    />
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
